import { useState } from 'react';
import { useTranslation } from '@/lib/i18n';
import { PageShell, SectionCard, Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui';
import {
  HomeBannerCreateButton,
  HomeBannerListPanel,
} from '../../components/HomeBannerListPanel';
import { useHomeBannersQuery } from '../../hooks/useHomeBannersQuery';
import { SectionProductMappingPanel } from '../components/SectionProductMappingPanel';
import { HeroBannerPreview } from '../components/HeroBannerPreview';
import { HeroCaptionPanel } from '../components/HeroCaptionPanel';

type MainPageTab = 'banners' | 'heroCaption' | 'sections';

const BannersTab = () => {
  // C-2: 미리보기는 활성 배너 전체를 한 페이지로 받아 스토어프론트와 동일하게 렌더.
  const previewQuery = useHomeBannersQuery(0, 100);
  const banners = previewQuery.data?.content ?? [];

  return (
    <div className="flex flex-col gap-5">
      <SectionCard title="스토어프론트 미리보기" description="활성 배너가 정렬 순서대로 노출됩니다.">
        <HeroBannerPreview banners={banners} />
      </SectionCard>
      <HomeBannerListPanel toolbar={<HomeBannerCreateButton />} />
    </div>
  );
};

export const MainPageManagePage = () => {
  const { t } = useTranslation('common');
  const [tab, setTab] = useState<MainPageTab>('banners');

  return (
    <PageShell
      title={t('cms.mainPage.title')}
      description={t('cms.mainPage.subtitle')}
      data-testid="main-page-manage-page"
    >
      <Tabs value={tab} onValueChange={(v) => setTab(v as MainPageTab)}>
        <TabsList>
          <TabsTrigger value="banners">{t('cms.mainPage.tabBanners')}</TabsTrigger>
          <TabsTrigger value="heroCaption">
            {t('cms.mainPage.tabHeroCaption', { defaultValue: '히어로 헤드라인' })}
          </TabsTrigger>
          <TabsTrigger value="sections">{t('cms.mainPage.tabSections')}</TabsTrigger>
        </TabsList>

        <TabsContent value="banners">
          <BannersTab />
        </TabsContent>

        <TabsContent value="heroCaption">
          <HeroCaptionPanel />
        </TabsContent>

        <TabsContent value="sections">
          <SectionProductMappingPanel />
        </TabsContent>
      </Tabs>
    </PageShell>
  );
};
